import { render } from "./teacher-detail-check.vue?vue&type=template&id=5df1f31e&scoped=true"
import script from "./teacher-detail-check.vue?vue&type=script&lang=js"
export * from "./teacher-detail-check.vue?vue&type=script&lang=js"

import "./teacher-detail-check.vue?vue&type=style&index=0&id=5df1f31e&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df1f31e"]])

export default __exports__